module.exports = __webpack_public_path__ + "static/media/login-bg.ad83c95f.jpg";